import React from 'react'
import AppointmentReport from 'components/AppointmentReport/index'

const Appointments = () => <AppointmentReport />

export default Appointments
